<div class="card">
  <div class="card-body">
    <div class="row tile-content align-items-stretch">
      <div class="col-12 d-flex flex-column justify-content-between">
        <div>
          <div class="tile-loyalty-icon mb-2">
            <svg>
              <use href="'/assets/images/svg_ico/icons.svg#ic_gift_light'"></use>
            </svg>
          </div>
          <div class="h1 tile-loyalty-title mb-0" i18n="@@loyalty-request-tile.loyaltyRequestTileTitle">
            Get rewards for your bookings
          </div>
          <p class="text-gray mb-0" i18n="@@loyalty-request-tile.loyaltyRequestTileDescription">
            With <b>Amadeus+Me</b>, you accumulate points for every booking you make. Use your points to choose gifts
            from the catalog.
          </p>
          <a routerLink="/amadeus-plus-me/enrollment">{{ moreDetails }}</a>
        </div>
        <div class="mt-4 mt-lg-0 d-grid">
          <p class="text-gray mb-2" i18n="@@loyalty-request-tile.loyaltyRequestTileManagerApproval">
            Your manager's approval is needed
          </p>
          <button
            id="loyalty-tile-request-button"
            type="button"
            class="btn btn-primary"
            [disabled]="requested"
            (click)="handleRequestAccess()"
          >
            {{ requested ? loyaltyRequestTileRequestedButton : loyaltyRequestTileRequestButton }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
